import { styled, Skeleton } from '@ori-ui/mui';
import type { VFC } from 'react';

import { DESKTOP_BREAKPOINT, TOP_NAV_HEIGHT, TOP_NAV_HEIGHT_MOBILE } from '../../constants';
import { TopAreaBlock } from '../TopAreaBlock';

const SQUARES_SIZE = 27;

const UnifiedSkeleton = styled(Skeleton)({
  transform: 'none',
});

const Root = styled('div')(({ theme }) => ({
  display: 'grid',
  position: 'fixed',
  alignItems: 'center',
  justifyContent: 'space-between',
  top: 0,
  left: 0,
  background: 'white',
  zIndex: theme.zIndex.appBar,
  width: '100vw',
  height: TOP_NAV_HEIGHT_MOBILE,
  gridTemplateColumns: '1fr 100px 1fr',
  padding: '0 17px',
  boxSizing: 'border-box',
  [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
    gridTemplateColumns: '1fr 180px 1fr',
    height: TOP_NAV_HEIGHT,
    padding: '0 45px 0 30px',
  },
  [theme.breakpoints.up('lg')]: {
    padding: '0 55px 0 40px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '0 75px 0 60px',
  },
}));

const LogoSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  width: 105,
  [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
    width: 180,
  },
}));

const LeftSideRoot = styled('div')({
  display: 'flex',
});

const LeftSideSkeletonItem = styled(UnifiedSkeleton)(({ theme }) => ({
  display: 'inline-block',
  '&:nth-of-type(2)': {
    marginLeft: 30,
    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      marginLeft: 42,
      marginRight: 40,
    },
  },
  '&:last-of-type': {
    display: 'none',
    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      display: 'block',
    },
  },
}));

const RightSideRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gridColumn: '3/4',
  justifySelf: 'end',
});

const SearchBarSkeleton = styled(UnifiedSkeleton)(() => ({
  borderRadius: '999px',
  marginRight: '50px',
  display: 'none',
  [DESKTOP_BREAKPOINT]: {
    display: 'block',
  },
}));

export const TopAreaSkeleton: VFC = () => (
  <TopAreaBlock>
    <Root>
      <LeftSideRoot>
        <LeftSideSkeletonItem
          height={SQUARES_SIZE}
          width={SQUARES_SIZE}
        />
        <LeftSideSkeletonItem
          height={SQUARES_SIZE}
          width={SQUARES_SIZE}
        />
        <LeftSideSkeletonItem
          height={SQUARES_SIZE}
          width={SQUARES_SIZE * 3}
        />
      </LeftSideRoot>
      <LogoSkeleton height="60%" />
      <RightSideRoot>
        <SearchBarSkeleton
          height={38}
          width={200}
        />
        <UnifiedSkeleton
          width={SQUARES_SIZE}
          height={SQUARES_SIZE}
        />
      </RightSideRoot>
    </Root>
  </TopAreaBlock>
);
